import React  from "react";


const LoyaltyTop = () => {
    return(
        <div className="w-full sm:mt-0 mt-20">
                    <div className="md:text-[32px] text-[20px] font-semibold sm:mb-7 mb-4">
                        Система лояльности
                    </div>
        </div>
    )
}

export default LoyaltyTop;